module.exports = __webpack_public_path__ + "img/AlinIonescu.c90446c3.svg";